import { render } from "./ProgrammingCategoryRatingsChart.vue?vue&type=template&id=cc9ee0a8&ts=true"
import script from "./ProgrammingCategoryRatingsChart.vue?vue&type=script&lang=ts"
export * from "./ProgrammingCategoryRatingsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__